module.exports = __webpack_public_path__ + "img/vi.b0387c95.png";